import { render, staticRenderFns } from "./TaxSetupWizard.vue?vue&type=template&id=f58f27f6&scoped=true&"
import script from "./TaxSetupWizard.vue?vue&type=script&lang=js&"
export * from "./TaxSetupWizard.vue?vue&type=script&lang=js&"
import style0 from "./TaxSetupWizard.vue?vue&type=style&index=0&id=f58f27f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58f27f6",
  null
  
)

export default component.exports